<template>
  <div class="container">
    <!-- 头部 -->
    <Header />

    <div class="news">
      <div class="top_img">
        <img :src="Baseurl+list.home_image" alt="">
      </div>
      <div class="public_title">
        <div class="pumain">
          <div class="pubbiao">{{list.name}}</div>
        </div>
      </div>
      
      <div class="news_two">
        <div class="twolist" v-if="page==1" v-for="(item,index) in toplist" :key="index" @click="toNewsdetails(item.id)">
          <div class="twoleft">
            <img :src="Baseurl+item.image" alt="">
          </div>
          <div class="tworight">
            <p class="time">{{item.f_time.slice(0,10)}}</p>
            <!-- <span class="twotit">{{item.title}}</span> -->
            <p class="text">{{item.title}}</p>
            <div class="details">Details</div>
          </div>
        </div>
        <div class="twolist" v-for="(item,index) in morelist" :key="index" @click="toNewsdetails(item.id)">
          <div class="twoleft">
            <img :src="Baseurl+item.image" alt="">
          </div>
          <div class="tworight">
            <p class="time">{{item.f_time.slice(0,10)}}</p>
            <!-- <span class="twotit">{{item.title}}</span> -->
            <p class="text">{{item.title}}</p>
            <div class="details">Details</div>
          </div>
        </div>
      </div>
      <div class="brief-anniu clearfix">
        <div class="anan">
          <p class="blo active" @click="prev()">Previous Page</p>
          <!-- <p class="blo" :class="page==index+1?'active':''" v-for="(item,index) in yeshu" :key="index" @click="qiehuan(index+1)">{{index+1}}</p> -->
          <p class="blo active" @click="next()">Next Page</p>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <Footer />
  </div>
</template>

<script>
  import Header from "../owned/header.vue"
  import Footer from "../owned/footer.vue"

  export default {
    components: {
      Header,
      Footer
    },
    data() {
      return {
        id: "",//二级模块ID
        module_id: '',//类型
        page:1,//新闻分页
        list:[],//页面内容
        toplist:[],//

        morelist:[],//下面条的新闻列表
        count:0,//新闻总条数
        yeshu:0,//总共有几页
      };
    },
    inject: ["reload"],
    created() {
      localStorage.setItem("navIndex",1)
      this.id = this.$route.query.id
      this.module_id = this.$route.query.module_id
      if(this.$route.query.page){
        this.page=parseInt(this.$route.query.page)
      }
      this.getinfo()
    },
    methods: {
      getinfo() {
        var that = this;
        that.$axios
          .get(`${this.Baseurl}/search_module?id=${that.id}&module_id=${that.module_id}&page=${that.page}`)
          .then(res => {
            // console.log(res)
            that.list= res.data.data
            console.log(that.list)
            that.toplist = res.data.data.top_news
            that.morelist = res.data.data.news
            that.count = res.data.data.count
            that.yeshu = Math.ceil(that.count/10)
          }).catch(err => console.log(err));
      },
      //去新闻详情页
      toNewsdetails(id) {
        this.$router.push({ name: 'Newsdetails',query:{
            id:id
        }})
      },
      // qiehuan(index){
      //   var that =this
      //   that.page = parseInt(index)
      //   that.$router.push({name:"News",query:{
      //     id:that.id,
      //     module_id:that.module_id,
      //     page:that.page
      //   }})
      //   this.reload()
      // },
      //上一页
      prev(){
        var that =this
        if(parseInt(that.page)>1){
          that.page = parseInt(that.page)-1
          that.$router.push({name:"News",query:{
            id:that.id,
            module_id:that.module_id,
            page:that.page
          }})
        }
        this.reload()
      },
      //下一页
      next(){
        var that =this
        if(parseInt(that.page)<parseInt(that.yeshu)){
          that.page = that.page+1
          that.$router.push({name:"News",query:{
            id:that.id,
            module_id:that.module_id,
            page:that.page
          }})
        }
        this.reload()
      },
    },
    mounted() {

    },

  };
</script>
<style scoped>
  .fenye {
    display: flex;
    align-items: center;
  }

  .top_img {
    width: 100%;
    /* height: 550px; */
  }

  .top_img>img {
    width: 100%;
    height: 100%;
    display: block;
  }

  .details {
    width: 17.467vw;
    height: 6.333vw;
    border: 0.133vw solid #D0D0D0;
    box-sizing: border-box;
    text-align: center;
    font-size: 3vw;
    color: #454545;
    line-height: 6.333vw;
    background-color: #f7f7f7;
    margin: initial;
    margin-top: 2vw;
    margin-left: auto;
  }

  .news_two {
    width: 92vw;
    margin: auto;
    margin-top: -3vw;
  }

  .twolist {
    width: 100%;
    display: flex;
    padding: 5.333vw 0;
    border-bottom: 2px solid #eeeeee;
  }

  .twoleft {
    width: 44.000vw;
    height: 23.333vw;
    overflow: hidden;
  }

  .twoleft>img {
    width: 100%;
    height: 100%;
    display: block;
    transition: all 0.3s;
  }

  .tworight {
    width: 44.000vw;
    margin-left: 3.8vw;
  }

  .tworight .time {
    font-size: 3vw;
    color: #454545;
  }

  /* .tworight .twotit {
    font-size: 18px;
    color: #454545;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    margin-top: 20px;
    width: 100%;
  } */

  .tworight .text {
    font-size: 3.5vw;
    color: #454545;
    line-height: 5vw;
    height: 10vw;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    /*要显示的行数*/
    -webkit-box-orient: vertical;
    margin-top: 1vw;
  }

  .brief-anniu {
    width: 92vw;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5vw 0px 5vw 0px;
    box-sizing: border-box;
  }

  .brief-anniu>.anan>p {
    background-color: #bdbdbd;
    color: #fff;
    font-size: 4vw;
    padding: 0 4vw;
    line-height: 9vw;
    margin: 2vw 5vw;
    width: 27vw;
    display: inline-block;
    text-align: center;
  }


  .brief-anniu>.anan .active {
    background-color: #c7161d;
  }
</style>